module.exports = __webpack_public_path__ + "img/fcus-checkpoint-model-selector.7a6a19da.png";